export function slideoutContact() {
  if($('.slideout-contact').length > 0){
    $('.slideout-contact').find('.slideout-trigger').on('click', function(){
      $(this).parent().toggleClass('active');
    });
  }
}



// WEBPACK FOOTER //
// ./scripts/components/slideout-contact.js